module.exports = __webpack_public_path__ + "static/media/adya.ba52580a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/adya.jpeg
// module id = 37
// module chunks = 0